import { AsyncThunkConfigWithRejectValue, createAsyncThunk } from '@/redux/createAsyncThunk';
import { getCreateAccountUnregisteredUserId } from './createAccountEmailVerification.selectors';
import { getDeployment } from '@/redux/modules/config';
import { isRateLimitPayload, VerificationRateLimitError } from './VerificationRateLimitError';
import { postSendEmailVerificationCode, postSubmitEmailVerificationCode } from './createAccountEmailVerification.api';
import {
    RESEND_COOLDOWN_MS,
    SendEmailVerificationCodePayload,
    SendEmailVerificationCodeResult,
    SubmitEmailVerificationCodePayload,
} from './createAccountEmailVerification.types';

export const sendEmailVerificationCode = createAsyncThunk<
    SendEmailVerificationCodeResult,
    SendEmailVerificationCodePayload,
    AsyncThunkConfigWithRejectValue
>(
    'la/ui/createAccountEmailVerification/sendEmailVerificationCode',
    async ({ email }, { getState, rejectWithValue }) => {
        try {
            const state = getState();
            const deployment = getDeployment(state);

            const { payload } = await postSendEmailVerificationCode({ deployment, email });

            return {
                cooldownCompletionTime: Date.now() + RESEND_COOLDOWN_MS,
                unregisteredUserId: payload,
            };
        } catch (originalError) {
            if (isRateLimitPayload(originalError)) {
                return rejectWithValue(new VerificationRateLimitError(originalError as string));
            }
            const error = typeof originalError === 'string' ? new Error(originalError) : (originalError as Error);
            return rejectWithValue(error);
        }
    }
);

export const submitEmailVerificationCode = createAsyncThunk<
    number,
    SubmitEmailVerificationCodePayload,
    AsyncThunkConfigWithRejectValue
>(
    'la/ui/createAccountEmailVerification/submitEmailVerificationCode',
    async ({ onSuccess, otp }, { getState, rejectWithValue }) => {
        const state = getState();
        const deployment = getDeployment(state);
        const unregisteredUserId = getCreateAccountUnregisteredUserId(state);
        try {
            const { payload } = await postSubmitEmailVerificationCode({ deployment, otp, unregisteredUserId });

            onSuccess();
            return payload;
        } catch (originalError) {
            const error = typeof originalError === 'string' ? new Error(originalError) : (originalError as Error);

            if (error.message === 'Internal Server Error - attempt to login with wrong otp code') {
                error.message = 'Failed to submit email verification code';
            }

            return rejectWithValue(error);
        }
    }
);
